import { forwardRef } from "react";
import { IMaskInput } from 'react-imask';

const ZipCodeMaskCustom = forwardRef(function ZipCodeMaskCustom(props, ref) {
    const { onChange, ...other } = props;
    return (
        <IMaskInput
            {...other}
            mask="00.000-000"
            definitions={{
                '0': /[0-9]/
            }}
            inputRef={ref}
            onAccept={(value) => onChange({ target: { name: props.name, value } })}
            overwrite
        />
    );
});

export default ZipCodeMaskCustom;

